import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../services/toast.service';
import { MvtService } from '../../../services/mvt.service';

@Component({
  selector: 'app-mvt-upload',
  templateUrl: './mvt-upload.component.html',
  styleUrls: ['./mvt-upload.component.scss']
})
export class MvtUploadComponent implements OnInit {

  file: File;
  fileContent: any;
  fileName: string;
  isBusy = false;


  constructor(private modalService: NgbModal, private fns: AngularFireFunctions, private mvtService: MvtService, private toastService: ToastService) {
  }

  ngOnInit(): void {
  }

  handleFileInput(files: FileList) {
    console.log(files.item(0));

    const fileReader = new FileReader();

    fileReader.onloadend = () => {
      this.fileContent = fileReader.result;
      this.file = files.item(0);
    };

    if (files.item(0) != null && files.item(0).size > 0) {
      console.log('start read file');
      this.fileName = files[0].name;
      fileReader.readAsText(files.item(0));
    } else {
      console.log('file is empty');
    }
  }

callFunction() {
  this.isBusy = true;
  this.mvtService.uploadMvt({ fileContent: this.fileContent, fileName: this.fileName }).subscribe((res) => {
    this.isBusy = false;
    if (res) {
     this.toastService.showSuccess('MVT file has been processed successfully!');
    }
  });
}
}
